import React from 'react';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import HelpAndSupportContainer from './components/HelpAndSupportContainer';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('helpAndSupport', key, options);

const HelpAndSupport: React.FC = () => {
  const omitRoutes = useTrialUserOmitRoutes();
  return (
    <>
      <SectionHeader title={t('header')} omitRoutes={omitRoutes} />
      <HelpAndSupportContainer />
    </>
  );
};

export default HelpAndSupport;
